import { IsString } from 'class-validator';
import { AuditFormDto } from './auditForm.dto';
import { AuditFormQuestionDto } from './auditFormQuestion.dto';
import { BaseDto } from '../base.dto';

export class AuditFormSectionDto extends BaseDto {
  @IsString()
  text: string;
  questions?: AuditFormQuestionDto[];
  auditForm: AuditFormDto;
  sort?: number;
  isDeleted?: boolean;
}
